/* mt-bf — oferta de Black Friday (01/11/2026): mueve las cuentas atrás hasta el fin REAL de la oferta y abre la ventana emergente.
   · Cuentas atrás: [data-mt-bf-reloj data-fin="ISO"]; formato «corto» en la barra («29 d 07 h»). A cero, esconde su caja
     ([data-mt-bf-oferta]) y la ventana deja de salir: después de la hora de fin no queda ningún aviso de esta oferta.
   · Ventana ([data-mt-bf-pop], snippets/mt-bf-popup): una vez por visita, a los N segundos (el doble en la ficha) o al ir a salir con
     el ratón; si se cierra, no vuelve en 12 horas. Espera si hay otra ventana abierta (Klaviyo, carrito, menú). */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const leer = (almacen, clave) => { try { return window[almacen].getItem(clave); } catch (e) { return null; } };
  const guardar = (almacen, clave, valor) => { try { window[almacen].setItem(clave, valor); } catch (e) { /* sin almacenamiento: no pasa nada */ } };

  let terminada = false;
  function pintar() {
    const ahora = Date.now();
    document.querySelectorAll('[data-mt-bf-reloj]').forEach((el) => {
      const fin = Date.parse(el.dataset.fin);
      if (!fin) return;
      const r = Math.max(0, Math.floor((fin - ahora) / 1000));
      if (r === 0) {
        terminada = true;
        const caja = el.closest('[data-mt-bf-oferta]');
        if (caja) caja.hidden = true; else el.hidden = true;
        return;
      }
      const desde = Date.parse(el.dataset.desde || '');
      el.classList.toggle('es-dias', !!desde && ahora < desde);
      const d = Math.floor(r / 86400), h = Math.floor((r % 86400) / 3600), m = Math.floor((r % 3600) / 60), s = r % 60;
      if (el.dataset.formato === 'corto') {
        el.textContent = d > 0 ? `${d} d ${pad(h)} h` : `${pad(h)} h ${pad(m)} min`;
        return;
      }
      const poner = (u, v) => { const b = el.querySelector(`[data-u="${u}"]`); if (b && b.textContent !== v) b.textContent = v; };
      poner('d', String(d)); poner('h', pad(h)); poner('m', pad(m)); poner('s', pad(s));
    });
    if (terminada) document.querySelectorAll('[data-mt-bf-oferta]').forEach((el) => { el.hidden = true; });
  }
  pintar();
  setInterval(pintar, 1000);

  /* ---------- Ventana emergente ---------- */
  const pop = document.querySelector('[data-mt-bf-pop]');
  if (!pop) return;
  const caja = pop.querySelector('[data-mt-bf-pop-caja]');
  const DOCE_HORAS = 12 * 3600 * 1000;
  let abierta = false;
  let foco = null;
  let intentos = 0;

  const yaVista = () => leer('sessionStorage', 'mt-bf-pop-vista') === '1' || (Date.now() - (Number(leer('localStorage', 'mt-bf-pop-cerrada')) || 0)) < DOCE_HORAS;
  const visible = (el) => !!el && el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
  const otraVentana = () => {
    if (document.querySelector('cart-drawer.active, .drawer.active, [data-mt-menu].es-abierto, .mt-menu.es-abierto')) return true;
    return [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some((el) => el !== caja && !caja.contains(el) && visible(el));
  };

  function abrir() {
    if (abierta || terminada || yaVista()) return;
    if (otraVentana()) {
      if (intentos++ < 4) setTimeout(abrir, 8000);
      return;
    }
    abierta = true;
    guardar('sessionStorage', 'mt-bf-pop-vista', '1');
    foco = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add('mt-bf-pop-abierta');
    requestAnimationFrame(() => requestAnimationFrame(() => pop.classList.add('es-visible')));
    const x = pop.querySelector('[data-mt-bf-pop-x]');
    if (x) setTimeout(() => x.focus({ preventScroll: true }), 60);
    document.addEventListener('keydown', teclas);
  }

  function cerrar() {
    if (!abierta) return;
    abierta = false;
    guardar('localStorage', 'mt-bf-pop-cerrada', String(Date.now()));
    pop.classList.remove('es-visible');
    document.documentElement.classList.remove('mt-bf-pop-abierta');
    document.removeEventListener('keydown', teclas);
    setTimeout(() => { pop.hidden = true; }, 280);
    if (foco && typeof foco.focus === 'function') foco.focus({ preventScroll: true });
  }

  function teclas(e) {
    if (e.key === 'Escape') { e.preventDefault(); cerrar(); return; }
    if (e.key !== 'Tab') return;
    const enfocables = [...caja.querySelectorAll('a[href], button:not([disabled])')].filter(visible);
    if (!enfocables.length) return;
    const primero = enfocables[0], ultimo = enfocables[enfocables.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  }

  pop.addEventListener('click', (e) => { if (e.target.closest('[data-mt-bf-pop-cerrar]')) cerrar(); });
  pop.querySelectorAll('[data-mt-bf-pop-ir]').forEach((a) => a.addEventListener('click', () => guardar('localStorage', 'mt-bf-pop-cerrada', String(Date.now()))));
  // Para probarla sin esperar: ?mt-bf-pop=1
  if (/[?&]mt-bf-pop=1/.test(location.search)) { setTimeout(() => { try { sessionStorage.removeItem('mt-bf-pop-vista'); localStorage.removeItem('mt-bf-pop-cerrada'); } catch (e) { /* nada */ } abrir(); }, 400); return; }

  if (yaVista()) return;
  const segundos = Math.max(2, Number(pop.dataset.segundos) || 6) * (pop.dataset.ficha === '1' ? 2 : 1);
  setTimeout(abrir, segundos * 1000);
  // Al ir a salir con el ratón (escritorio): una vez
  document.addEventListener('mouseout', function salir(e) {
    if (e.relatedTarget || e.clientY > 0) return;
    document.removeEventListener('mouseout', salir);
    abrir();
  });
})();
